<div tabindex="0" pRipple (click)="overlayPanel.toggle($event)" class="overlay-toggler">
  <i
    class="text-color"
    [ngClass]="IconKey.TopbarInfo | icon"
    [ospTooltip]="'modules.navigation.topbar.helpcenter.tooltip' | translate"
    tooltipPosition="bottom"
  ></i>
</div>

<osp-overlay-panel #op>
  <div header>
    <h3>{{ 'help.general.helpcenter.title' | translate }}</h3>
  </div>
  <div body>
    <div
      class="help-body"
      [innerHTML]="'help.general.helpcenter.osp.content' | translate: { helpicon: IconKey.BreadcrumbHelpSwitch | icon }"
    ></div>
  </div>
  <div footer>
    <div class="help-footer">
      <div class="help-labels">
        @if (version) {
          <span>{{ 'help.general.helpcenter.version' | translate: { value: version } }}</span>
        }
        <span>{{ 'help.general.helpcenter.gitHash' | translate: { value: commit } }}</span>
      </div>
      <osp-button
        [category]="'secondary'"
        (onClick)="onReleaseInfoClick()"
        [label]="'help.general.helpcenter.releaseInfo' | translate"
      />
    </div>
  </div>
</osp-overlay-panel>
